module.exports = __webpack_public_path__ + "static/img/LOGO- white@2x.dc55452e.png";